import { PendingRequestType } from 'types/approval';

export const getFormattedTransaction = (transaction: PendingRequestType) => ({
  id: transaction.request_data?.bulk_payout_id || null,
  request_id: transaction.request_id,
  date: transaction.requested_date,
  status: transaction.status,
  to_from: transaction.request_data?.to_from,
  initiator: transaction.request_data?.initiator,
  source_amount: transaction.request_data?.source_amount,
  source_currency: transaction.request_data?.source_currency || transaction.request_data?.source_currency_code,
  receiving_amount: transaction.request_data?.receiving_amount,
  receiving_currency: transaction.request_data?.receiving_currency_code,
  request_type: transaction.request_type,
  beneficiary_count: transaction.request_data?.beneficiary_count,
  quote_request_data: transaction.request_data?.quote_request_data,
  account_id: transaction?.request_data?.account_id ?? transaction?.request_data?.quote_request_data?.account_id,
  payout_count: transaction?.request_data?.payout_count,
});
